import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Course, ExternalCourse } from 'graphqlAPI'
import { joinKeys } from 'helpers/translations.helper'
import {
  createRouteCoursePreview,
  createRouteMonitoringCourse,
  createRouteMonitoringExternalCourse,
} from 'enum/routes'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { useAccess } from 'contexts/AccessContext'
import { prefixTranslation } from './common'
import optionStyles from './Options.module.scss'

type Data = Course | ExternalCourse

interface IProps {
  course: Data
}

const Options: React.FC<IProps> = ({ course }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const { access } = useAccess()

  const { id, __typename } = course
  const handleDropdownClick = (nextShow: boolean) => {
    setShow(nextShow)
  }

  const canView = access.canAccessCourseSheet()
  const isAllowedToPreview = access.canPreviewCourse()

  const isExternalCourse = __typename === 'ExternalCourse'

  const hasVisibleOptions = canView || (isAllowedToPreview && !isExternalCourse)

  if (!hasVisibleOptions) {
    return null
  }

  return (
    <div
      className={show ? optionStyles.menuOpen : undefined}
      data-menu-open={show ? 'true' : undefined}
    >
      <DropdownButton
        show={show}
        disabled={loading}
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={(nextShow) => handleDropdownClick(nextShow)}
      >
        {canView && (
          <Link
            className={styles['option-item']}
            to={
              isExternalCourse
                ? createRouteMonitoringExternalCourse({ id: `${id}` })
                : createRouteMonitoringCourse({ id: `${id}` })
            }
            onClick={() => setShow(false)}
          >
            {t(joinKeys(prefixTranslation, 'viewCourseSheet'), {
              defaultValue: t(joinKeys(prefixTranslation, 'view')),
            })}
          </Link>
        )}
        {isAllowedToPreview && !isExternalCourse && (
          <Link
            className={
              course['integrationCourseLink']
                ? `${styles['option-item']} ${optionStyles.optionDisabled}`
                : styles['option-item']
            }
            to={createRouteCoursePreview({ courseId: `${id}` })}
            onClick={() => setShow(false)}
          >
            {t(joinKeys(prefixTranslation, 'preview'))}
          </Link>
        )}
      </DropdownButton>
    </div>
  )
}

export default Options
